import { h } from 'preact';
import styled from 'react-emotion';

const ZoomImageWrapper = styled('div')`
  position: absolute;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  border-radius: ${props => props.radius}px;
  ${props => (props.zIndex ? `z-index:${props.zIndex}` : '')};
  ${props => (props.renderToContainer ? '' : 'overflow: hidden;')};
`;

const Image = styled('img')`
  position: absolute;
  translate: -50% -50%;
  inset: 50%;
  opacity: 0;
`;

const ZoomImage = props => {
  const wrapperStyles = {
    backgroundColor: props.zoomed ? props.bgColor : 'transparent',
    left: `${props.left}px`,
    top: `${props.top}px`,
    transition: `background-color 150ms`
  };

  const imgStyles = {
    // Small img get stretched while bigger img loads
    width: `${props.width}px`,
    height: `${props.height}px`,
    maxWidth: 'none',
    maxHeight: 'none',
    objectFit: 'contain', // maintain aspect ratio

    ...(props.transition && {
      transition: 'all 150ms'
    }),

    ...(props.zoomed && {
      // when zoomed
      width: `${props.width * props.level}px`,
      height: `${props.height * props.level}px`,
      opacity: 1,
      translate: `
        calc(-50% - ${props.lensLeft * props.level}px)
        calc(-50% - ${props.lensTop * props.level}px)
      `
    })
  };

  return (
    <ZoomImageWrapper
      data-test="zoom-flyout-wrap"
      width={props.width}
      height={props.height}
      level={props.level}
      radius={props.radius}
      zIndex={props.zIndex}
      spacing={props.spacing}
      renderToContainer={props.renderToContainer}
      style={wrapperStyles}
    >
      <Image
        itemprop="image"
        src={props.url}
        style={imgStyles}
        alt={props.alt}
        level={props.level}
      />
    </ZoomImageWrapper>
  );
};

export default ZoomImage;
